export default "__VITE_ASSET__DIAyS1yj__"